export default __webpack_public_path__ + "static/media/homeOrangeIcon.ef716a29.png";